import script from "./ChangeStatusActiveForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeStatusActiveForm.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeStatusActiveForm.vue?vue&type=style&index=0&id=a13f39b6&lang=scss"

const __exports__ = script;

export default __exports__